import { useSubscription } from 'src/context/subscription-context';

export function useTariff() {
  const {
    tariff,
    tariffLimits,
    canUseFeature,
    getLimit,
    isAtLimit,
    guardFeature,
    guardLimit,
    handleTariffApiError,
    openUpgradeDialog,
  } = useSubscription();

  return {
    tariff,
    tariffLimits,
    canUseFeature,
    getLimit,
    isAtLimit,
    guardFeature,
    guardLimit,
    handleTariffApiError,
    openUpgradeDialog,
  };
}

export { TARIFF_FEATURES, TARIFF_LIMIT_RESOURCES } from 'src/types/tariff';
